import { render, staticRenderFns } from "./FeedbackDetailDialog.vue?vue&type=template&id=8a98ba88&scoped=true"
import script from "./FeedbackDetailDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDetailDialog.vue?vue&type=style&index=0&id=8a98ba88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a98ba88",
  null
  
)

export default component.exports